// @flow
import * as React from 'react';
import { GenderFemale, GenderMale } from '@phosphor-icons/react';
import { Stack, Typography } from '@mui/material';
import { Gender } from '@coverright/data-access/types/enrollment';

type Props = {
  value?: Gender | string | null;
};
export const GenderView = ({value}: Props) => (
  value ? <Stack gap={.7} direction={'row'} alignItems={'center'}>
    {value === 'M' ? <GenderMale color={'#3E72BB'} size={18} weight={'bold'} /> : <GenderFemale color={'#c64096'} size={18} weight={'bold'} />}
    <Typography fontWeight={500} fontSize={14}>
      {value === 'M' ? 'Male' : 'Female'}
    </Typography>
  </Stack> : null
)
